import { forwardRef } from 'react';
import { ListProps } from './types';
import clsx from 'clsx';
import { styleList } from './style';

/**
 *  UI Component
 */
const List = forwardRef<HTMLUListElement, ListProps>(function List(props, ref) {
  // Apply Default props values
  props = {
    ...{
      size: 'normal'
    },
    ...props
  };

  const { className, children, size, ...rest } = props;

  const cls = styleList(props);
  return (
    <ul className={clsx(cls, className)} ref={ref} {...rest}>
      {children}
    </ul>
  );
});

export default List;
